import { render, staticRenderFns } from "./mycollection.vue?vue&type=template&id=9268c1e8&"
import script from "./mycollection.vue?vue&type=script&lang=js&"
export * from "./mycollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports